<div class="new-poll-page-container">
  <h1>Ð¡Ð¾Ð·Ð´Ð°ÑÑ Ð¾Ð¿ÑÐ¾Ñ</h1>

  <div class="new-poll-block">

    <form *ngIf="formGroup" [formGroup]="formGroup">

      <div class="question-topic">
        <label>Ð¢ÐµÐ¼Ð° Ð¾Ð¿ÑÐ¾ÑÐ°</label>
        <input formControlName="question" type="text" />
      </div>

      <div formArrayName="answerOptions">
        <div *ngFor="let answer of formGroup.controls['answerOptions']['controls']; let i = index" class="option-block">

          <div class="option">
            <label>ÐÐ°ÑÐ¸Ð°Ð½Ñ Ð¾ÑÐ²ÐµÑÐ° {{i + 1}}</label>
            <input class="form-control" formControlName="{{i}}" />
          </div>

          <div class="remove-block">
            <mat-icon>delete</mat-icon>
            <span (click)="removeOption(i)">Ð£Ð´Ð°Ð»Ð¸ÑÑ</span>
          </div>

        </div>
      </div>

    </form>

    <div class="add-block" (click)="addOption()">
      <mat-icon>add_circle_outline</mat-icon>
      <span>ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð²Ð°ÑÐ¸Ð°Ð½Ñ</span>
    </div>

  </div>

  <arm-spinner *ngIf="loading" class="spinner poll-spinner"></arm-spinner>

  <button [disabled]="buttonDisable"
          [ngClass]="{'disable-active' : buttonDisable}"
          (click)="sendPoll()">ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ</button>

</div>
